var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.099 16.66C10.1109 15.0117 11.4505 13.6818 13.0989 13.6818H30.9781C32.6435 13.6818 33.9902 15.0383 33.9781 16.7036L33.901 27.3172C33.8891 28.9655 32.5495 30.2955 30.9011 30.2955H13.0219C11.3565 30.2955 10.0098 28.939 10.0219 27.2737L10.099 16.66Z",
    stroke: "#3E3A39",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.6136L20.1265 23.9111C21.2219 24.787 22.7781 24.787 23.8735 23.9111L33 16.6136",
    stroke: "#3E3A39",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.44227d02553429fc8c3cb973529bcdc3.svg";
export { ForwardRef as ReactComponent };